import React from 'react';
import { useSelector } from 'react-redux';
import { ReduxControls } from 'rhombus-react';
import { getFormValues } from 'redux-form';
import { CREATIVE_ASSET_TYPES } from 'utils/constants';
import { useFlag } from "@innovid/feature-flags-react";
import { FEATURE_FLAGS } from "../../featureFlag/featureFlag";

function FrameForThumbnailInput({ input, meta, isEditMode, ...forwardedProps }) {
	const [adType] = (input?.name || "").split(".");
	const { assetType } = useSelector(state =>
		getFormValues(meta.form)(state)?.[adType] || {}
	);
	const isAESocialVersionsFlagEnabled = useFlag(FEATURE_FLAGS.AFTER_EFFECTS_SOCIAL_VERSIONS);

	if (!isAESocialVersionsFlagEnabled || assetType !== CREATIVE_ASSET_TYPES.AFTER_EFFECTS || isEditMode) {
		return null;
	}

	return <ReduxControls.Input input={input} meta={meta} {...forwardedProps} />;
}

FrameForThumbnailInput.displayName = "FrameForThumbnailInput";

export const frameForThumbnail = {
	name: "frameNumber",
	label: "Frame for Thumbnail",
	placeholder: "Enter frame number",
	className: "full-width",
	component: FrameForThumbnailInput,
	type: "number",
	min: 0,
	parse: (value) => {
		return value === "" || value === null || value === undefined ? null : parseInt(value);
	},
};
